document.addEventListener('DOMContentLoaded', function(){
  document.querySelectorAll('[data-floating-header]').forEach(function(root){
    const body = document.body;
    const panel = root.querySelector('[data-search-panel]');
    const toggle = root.querySelector('[data-search-toggle]');
    const closeBtn = root.querySelector('[data-search-close]');
    const input = root.querySelector('[data-search-input]');
    const historyWrap = root.querySelector('[data-search-history]');
    const chips = root.querySelector('[data-history-chips]');
    const clearBtn = root.querySelector('[data-history-clear]');
    
    // 检查是否为固定模式（非首页）
    const isFixedMode = root.classList.contains('mt-floating-header--fixed');

    function setBodyOffset(){ 
      if (isFixedMode) {
        // 固定模式下公告栏已经通过CSS固定在顶部
        const announcementBar = document.querySelector('.announcement-bar-section');
        let announcementBarHeight = 0;
        
        if (announcementBar) {
          announcementBarHeight = announcementBar.offsetHeight;
        }
        
        // 设置头部位置在固定公告栏下方
        root.style.top = announcementBarHeight + 'px';
        
        // 给body添加padding-top以避免内容被遮挡（公告栏+头部高度）
        const headerHeight = root.offsetHeight;
        const totalOffset = announcementBarHeight + headerHeight;
        body.style.paddingTop = totalOffset + 'px';
      } else {
        // 首页悬浮模式下不需要padding-top，保持原有位置
        body.style.paddingTop = '0px';
        root.style.top = ''; // 清除动态设置的top值
      }
    }

    // 搜索面板状态追踪
    let isSearchPanelOpen = false;

    function openPanel(){ 
      if(panel){ 
        panel.hidden = false; 
        renderHistory(); 
        input && input.focus(); 
        setBodyOffset(); 
        isSearchPanelOpen = true;
      } 
    }
    
    function closePanel(){ 
      if(panel){ 
        panel.hidden = true; 
        setBodyOffset(); 
        isSearchPanelOpen = false;
      } 
    }

    function togglePanel(){
      if(isSearchPanelOpen){
        closePanel();
      } else {
        openPanel();
      }
    }

    toggle && toggle.addEventListener('click', togglePanel);
    closeBtn && closeBtn.addEventListener('click', closePanel);

    root.addEventListener('keydown', function(e){ 
      if(e.key === 'Escape' && isSearchPanelOpen) closePanel(); 
    });

    function getHistory(){
      try{ return JSON.parse(localStorage.getItem('mt_search_history')||'[]'); }catch(e){ return []; }
    }
    function setHistory(list){ localStorage.setItem('mt_search_history', JSON.stringify(list.slice(0,8))); }

    function addHistory(term){
      const t = (term||'').trim(); if(!t) return;
      const list = getHistory();
      const idx = list.indexOf(t); if(idx>-1) list.splice(idx,1);
      list.unshift(t); setHistory(list); renderHistory();
    }

    function renderHistory(){
      const list = getHistory();
      if(!historyWrap) return;
      historyWrap.hidden = list.length === 0;
      if(!chips) return;
      chips.innerHTML = '';
      list.forEach(function(term){
        const btn = document.createElement('button');
        btn.type = 'button'; btn.textContent = term;
        btn.addEventListener('click', function(){ input.value = term; input.form && input.form.submit(); });
        chips.appendChild(btn);
      });
    }

    clearBtn && clearBtn.addEventListener('click', function(){ setHistory([]); renderHistory(); });

    input && input.form && input.form.addEventListener('submit', function(){ addHistory(input.value); });

    // 初始渲染
    renderHistory();
    
    // 确保全局只存在一个 cart-notification，避免与 header 重复渲染冲突
    (function ensureSingleCartNotification(){
      try {
        const nodes = Array.prototype.slice.call(document.querySelectorAll('cart-notification'));
        if (nodes.length <= 1) return;
        // 优先保留包含必要容器的实例
        function hasRequiredContainers(el){
          return el && el.querySelector('#cart-notification-product') && el.querySelector('#cart-notification-button');
        }
        let keeper = nodes.find(hasRequiredContainers) || nodes[0];
        nodes.forEach(function(n){ if (n !== keeper) n.parentNode && n.parentNode.removeChild(n); });
      } catch(e){}
    })();

    // 延迟设置body offset，确保所有元素都已加载
    setTimeout(function() {
      setBodyOffset();
    }, 100);
    
    // 监听窗口大小变化，重新计算body offset
    window.addEventListener('resize', function() {
      // 使用setTimeout避免频繁调用
      clearTimeout(window.resizeTimer);
      window.resizeTimer = setTimeout(setBodyOffset, 100);
    });
    
    // 监听DOM变化，以防header高度发生变化
    if (isFixedMode && window.ResizeObserver) {
      const resizeObserver = new ResizeObserver(function() {
        setBodyOffset();
      });
      resizeObserver.observe(root);
      
      // 同时监听公告栏的高度变化
      const announcementBar = document.querySelector('.announcement-bar-section');
      if (announcementBar) {
        resizeObserver.observe(announcementBar);
      }
    }

    // ===== 滚动时隐藏/显示（仅固定模式） =====
    if (isFixedMode) {
      let lastScrollY = window.scrollY || 0;
      let ticking = false;
      let accumulated = 0;
      const threshold = 16; // 像素阈值，避免微小滚动抖动

      function shouldIgnore() {
        // 搜索面板或移动菜单打开时，不隐藏头部
        if (isSearchPanelOpen) return true;
        if (root.classList.contains('is-mobile-menu-open')) return true;
        return false;
      }

      function updateOnScroll() {
        ticking = false;
        const currentY = window.scrollY || 0;
        const delta = currentY - lastScrollY;

        // 顶部回到0时，确保显示
        if (currentY <= 0) {
          root.classList.remove('is-hidden-on-scroll');
          root.classList.add('is-visible-on-scroll');
          accumulated = 0;
          lastScrollY = currentY;
          return;
        }

        if (shouldIgnore()) {
          root.classList.remove('is-hidden-on-scroll');
          root.classList.add('is-visible-on-scroll');
          lastScrollY = currentY;
          accumulated = 0;
          return;
        }

        // 累积滚动距离，超过阈值再触发
        accumulated += delta;
        if (Math.abs(accumulated) < threshold) {
          lastScrollY = currentY;
          return;
        }

        if (accumulated > 0) {
          // 向下滚动 -> 隐藏
          root.classList.add('is-hidden-on-scroll');
          root.classList.remove('is-visible-on-scroll');
        } else {
          // 向上滚动 -> 显示
          root.classList.remove('is-hidden-on-scroll');
          root.classList.add('is-visible-on-scroll');
        }

        // 重置累计并同步基准
        accumulated = 0;
        lastScrollY = currentY;
      }

      window.addEventListener('scroll', function () {
        if (!ticking) {
          window.requestAnimationFrame(updateOnScroll);
          ticking = true;
        }
      }, { passive: true });

      // 初始状态：显示
      root.classList.add('is-visible-on-scroll');
    }

    // Submenu hover -> toggle class for rounded corners on inner
    const itemsWithSubmenu = root.querySelectorAll('.mt-floating-header__menu-item');
    let hoverTimer;
    itemsWithSubmenu.forEach(function(item){
      const submenu = item.querySelector('.mt-floating-header__submenu');
      if(!submenu) return;
      function openState(){
        clearTimeout(hoverTimer);
        root.classList.add('is-submenu-open');
        item.classList.add('has-open-submenu');
      }
      function closeState(){
        clearTimeout(hoverTimer);
        hoverTimer = setTimeout(function(){ 
          root.classList.remove('is-submenu-open');
          item.classList.remove('has-open-submenu');
        }, 100);
      }
      item.addEventListener('mouseenter', function(){
        openState();
        submenu.classList.add('is-open');
      });
      item.addEventListener('mouseleave', function(){
        closeState();
        submenu.classList.remove('is-open');
      });
      submenu.addEventListener('mouseenter', function(){
        openState();
        submenu.classList.add('is-open');
      });
      submenu.addEventListener('mouseleave', function(){
        closeState();
        submenu.classList.remove('is-open');
      });
    });

    // 移动端菜单功能
    const mobileMenuBtn = root.querySelector('[data-mobile-menu-toggle]');
    const mobileDropdown = root.querySelector('[data-mobile-dropdown]');
    const menuIcon = mobileMenuBtn ? mobileMenuBtn.querySelector('.mt-floating-header__menu-icon') : null;
    const closeIcon = mobileMenuBtn ? mobileMenuBtn.querySelector('.mt-floating-header__close-icon') : null;

    console.log('Mobile menu elements:', { mobileMenuBtn, mobileDropdown, menuIcon, closeIcon }); // 调试信息

    if (mobileMenuBtn && mobileDropdown) {
      let isMobileMenuOpen = false;

      function openMobileMenu() {
        console.log('Opening mobile menu'); // 调试信息
        mobileDropdown.hidden = false;
        isMobileMenuOpen = true;
        root.classList.add('is-mobile-menu-open');
        
        // 切换图标
        if (menuIcon) menuIcon.style.display = 'none';
        if (closeIcon) closeIcon.style.display = 'block';
      }

      function closeMobileMenu() {
        console.log('Closing mobile menu'); // 调试信息
        mobileDropdown.hidden = true;
        isMobileMenuOpen = false;
        root.classList.remove('is-mobile-menu-open');
        
        // 切换图标
        if (menuIcon) menuIcon.style.display = 'block';
        if (closeIcon) closeIcon.style.display = 'none';
      }

      mobileMenuBtn.addEventListener('click', function(e) {
        console.log('Mobile menu button clicked'); // 调试信息
        e.preventDefault();
        e.stopPropagation();
        
        if (isMobileMenuOpen) {
          closeMobileMenu();
        } else {
          openMobileMenu();
        }
      });

      // 点击外部关闭菜单
      document.addEventListener('click', function(e) {
        if (isMobileMenuOpen && !root.contains(e.target)) {
          closeMobileMenu();
        }
      });

      // ESC键关闭菜单
      document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && isMobileMenuOpen) {
          closeMobileMenu();
        }
      });
    }

    // ===== 购物车数量气泡（与 header.liquid 逻辑一致） =====
    (function initCartBubble(){
      const btn = root.querySelector('.mt-floating-header__cart-btn');
      if (!btn) return;

      // 保护自定义 SVG：若被其他脚本替换为原生图标，立即恢复
      (function lockCustomCartIcon(){
        // 记录初始的自定义 SVG（克隆模板）
        const initialSvg = btn.querySelector('svg');
        if (!initialSvg) return;
        const svgTemplate = initialSvg.cloneNode(true);

        function ensureCustomSvgPresent(){
          // 移除可能插入的原生 .svg-wrapper
          btn.querySelectorAll('.svg-wrapper').forEach(function(n){ n.parentNode && n.parentNode.removeChild(n); });
          // 若不存在 SVG，则在最前面插入自定义 SVG
          if (!btn.querySelector('svg')) {
            btn.insertBefore(svgTemplate.cloneNode(true), btn.firstChild);
          }
        }

        // 观察任何子节点变更，确保自定义 SVG 持续存在
        const mo = new MutationObserver(function(){ ensureCustomSvgPresent(); });
        mo.observe(btn, { childList: true, subtree: true });

        // 在关键事件后再校正一次
        ensureCustomSvgPresent();
        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          try {
            subscribe(PUB_SUB_EVENTS.cartUpdate, function(){ ensureCustomSvgPresent(); });
          } catch(e){}
        }
      })();

      function ensureBubble() {
        let bubble = btn.querySelector('.cart-count-bubble');
        if (!bubble) {
          bubble = document.createElement('div');
          bubble.className = 'cart-count-bubble';
          btn.appendChild(bubble);
        }
        return bubble;
      }

      function setCount(count){
        const n = Number(count) || 0;
        const bubble = ensureBubble();
        bubble.innerHTML = '';
        if (n === 0) {
          bubble.remove();
          return;
        }
        if (n < 100) {
          const span = document.createElement('span');
          span.setAttribute('aria-hidden', 'true');
          span.textContent = String(n);
          bubble.appendChild(span);
        }
        const sr = document.createElement('span');
        sr.className = 'visually-hidden';
        sr.textContent = (window.themeStrings && window.themeStrings.cart_count) ? window.themeStrings.cart_count.replace('[count]', n) : String(n);
        bubble.appendChild(sr);
      }

      function fetchCount(){
        return fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' })
          .then(function(r){ return r.json(); })
          .then(function(data){ return data.item_count; });
      }

      // 避免频繁拉取：200ms 冷却
      let lastFetchTs = 0;
      function fetchLatestCountWithCooldown(){
        const now = Date.now();
        if (now - lastFetchTs < 200) return;
        lastFetchTs = now;
        fetchCount().then(setCount).catch(function(){});
      }

      // 初始
      if (window.cart && typeof window.cart.item_count === 'number') {
        setCount(window.cart.item_count);
      } else {
        fetchLatestCountWithCooldown();
      }

      // 订阅主题事件
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        try {
          subscribe(PUB_SUB_EVENTS.cartUpdate, function(evt){
            if (evt && evt.cartData && typeof evt.cartData.item_count === 'number') {
              setCount(evt.cartData.item_count);
            } else {
              fetchLatestCountWithCooldown();
            }

            // 若来源是 product-form，则强制触发原生加购弹窗
            try {
              if (evt && evt.source === 'product-form' && evt.cartData) {
                const cn = document.querySelector('cart-notification');
                if (cn && typeof cn.renderContents === 'function') {
                  cn.renderContents(evt.cartData);
                }
              }
            } catch(e){}
          });
        } catch(e) { /* ignore */ }
      }

      // 标签页可见性/返回页面时，主动同步一次
      document.addEventListener('visibilitychange', function(){
        if (document.visibilityState === 'visible') fetchLatestCountWithCooldown();
      });
      window.addEventListener('pageshow', function(){
        fetchLatestCountWithCooldown();
      });
    })();
  });
});


